import { useQuery } from '@tanstack/react-query';
import { useGraphneAPI } from '@nexelem/graphne-api';

export const productionQueuesQueryKey = ['production-queues'];

export const useProductionQueues = (enabled?: boolean) => {
  const api = useGraphneAPI();

  return useQuery({
    queryKey: productionQueuesQueryKey,
    queryFn: () => api.getGraphneQueues(),
    enabled,
  });
};
